import { Injectable, TemplateRef } from '@angular/core';
import { Toast, ToastOption } from './toast.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: Toast[] = [];
  defaultOption: ToastOption = {
    ariaLive: 'polite',
    autohide: true,
    delay: 10000,
    classname: ''
  };

  show(textOrTpl: string | TemplateRef<any>, options: ToastOption = this.defaultOption) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
